import * as yup from "yup";
import { Validation } from "../../utils/Validation.utils";
export const MasqueradeToOrganizationSchema = yup.object().shape({
    organizationId: yup.string().required(Validation.Required)
});
